export function reducerTeams(state, action) {
  switch (action.type) {
    case "SET_IS_LOADING":
      return {
        ...state,
        isLoading: action.isLoading
      };
    case "SET_SELECTED_GROUP_ID":
      return {
        ...state,
        selectedGroupId: action.selectedGroupId
      };
    case "SET_TEAM_NAME":
      return {
        ...state,
        teamName: action.teamName
      };
    case "SET_DESCRIPTION":
      return {
        ...state,
        description: action.description
      };
    case "SET_SELECTED_ROLE":
      return {
        ...state,
        selectedRole: action.selectedRole
      };
    default:
      return state;
  }
}